module.exports = __webpack_public_path__ + "static/media/room4_1.8e18d0d8.JPG";